import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../../atoms/buttons/enums.js';
import '../../utilities/dom-helpers/index.js';
import { normalizeUnicodeText } from '../../../common/navigation-titles.js';
import css_248z from './main-nav-item.scss.js';
import img from '../../../../assets/images/chevron-down.svg.js';

class MainNavItem extends s {
    constructor() {
        super(...arguments);
        this.isActive = false;
        this.link = '';
        this.title = '';
        this.hasItems = false;
        this.panelId = '';
        this.ariaLabel = '';
        this.isNoFollow = false;
    }
    get normalizedTitle() {
        return normalizeUnicodeText(this.title);
    }
    handleClickOrKey(e) {
        if (e instanceof KeyboardEvent) {
            if (e.key === 'Escape') {
                if (this.isActive) {
                    e.preventDefault();
                    this.dispatchEvent(new CustomEvent('panel-close', {
                        bubbles: true,
                        composed: true,
                        detail: { moveFocusNext: false },
                    }));
                }
                return;
            }
            if (!['Enter', ' '].includes(e.key))
                return;
        }
        e.preventDefault();
        const keyboard = e instanceof KeyboardEvent;
        // If this item has sub-items, keep existing toggle behavior
        if (this.hasItems) {
            this.dispatchEvent(new CustomEvent('nav-item-toggle', {
                bubbles: true,
                composed: true,
                detail: { id: this.title, active: true, keyboard },
            }));
            return;
        }
        // No sub-items: navigate to link if provided
        if (this.link) {
            // use assign so history is preserved; change to replace() if needed
            // eslint-disable-next-line no-undef
            globalThis.location.assign(this.link);
            return;
        }
        // Fallback: still dispatch toggle if no link and no items
        this.dispatchEvent(new CustomEvent('nav-item-toggle', {
            bubbles: true,
            composed: true,
            detail: { id: this.title, active: true, keyboard },
        }));
    }
    _onHover() {
        this.dispatchEvent(new CustomEvent('nav-hover', {
            bubbles: true,
            composed: true,
            detail: { id: this.title, active: true },
        }));
    }
    _onLeave() {
        this.dispatchEvent(new CustomEvent('nav-hover', {
            bubbles: true,
            composed: true,
            detail: { id: this.title, active: false },
        }));
    }
    render() {
        const arrowIcon = this.hasItems
            ? $ `<img src="${img}" alt="" class="arrow-icon">`
            : null;
        if (this.hasItems) {
            return $ `<div class="main-nav-link-container"><button id="${this.panelId}-button" class="main-nav-link ${this.isActive} ${this.hasItems
                ? 'has-items'
                : ''}" type="button" aria-haspopup="menu" aria-expanded="${this.isActive}" aria-controls="panel-${this.panelId
                .toLowerCase()
                .replace(/\s+/g, '-')}" title="${this.normalizedTitle || w}" aria-label="${this.ariaLabel || this.normalizedTitle || 'Button'}" @click="${this.handleClickOrKey}" @keydown="${this.handleClickOrKey}" @mouseenter="${this._onHover}" @mouseleave="${this._onLeave}">${this.normalizedTitle}</button> ${arrowIcon}</div>`;
        }
        return $ `<div class="main-nav-link-container"><a href="${this.link}" class="main-nav-link" title="${this.normalizedTitle || w}" aria-label="${this.ariaLabel || this.normalizedTitle || 'Link'}" target="${this.target || w}" rel="${this.isNoFollow ? 'nofollow' : 'follow'}" @mouseenter="${this._onHover}" @mouseleave="${this._onLeave}"><span>${this.normalizedTitle}</span></a></div>`;
    }
}
MainNavItem.styles = css_248z;
__decorate([
    e({ type: Boolean })
], MainNavItem.prototype, "isActive", void 0);
__decorate([
    e()
], MainNavItem.prototype, "link", void 0);
__decorate([
    e()
], MainNavItem.prototype, "title", void 0);
__decorate([
    e({ type: Boolean })
], MainNavItem.prototype, "hasItems", void 0);
__decorate([
    e({ type: String, reflect: true })
], MainNavItem.prototype, "panelId", void 0);
__decorate([
    e()
], MainNavItem.prototype, "ariaLabel", void 0);
__decorate([
    e()
], MainNavItem.prototype, "target", void 0);
__decorate([
    e({ type: Boolean })
], MainNavItem.prototype, "isNoFollow", void 0);
customElements.define('main-nav-item', MainNavItem);

export { MainNavItem };
